import React, { Component, Fragment } from 'react';
import { useStyles } from '../../../styles/jss/RequestForSignetApprovalForm';
import {
  CssBaseline,
  Paper,
  Stepper,
  Button,
  Typography,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import withTranslations from '../../../utils/HighOrderComponent';
import FirstStep from './FirstStep';
import SecondStep from './SecondStep';
import ThirdStep from './ThirdStep';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import {
  languageAndScript,
  requestForSignetApprovalStatuses,
  uploadFileMaxSize,
  notificationTypeError,
} from '../../../constants/globals';
import { confirmDialog } from '../../Reusable/ConfirmDialog';
import {
  checkFileFormat,
  checkIfUserHasAutonomousProvince,
  createNotification,
  getFilesForUpload,
} from '../../../utils';

class RequestForSignetApprovalForm extends Component {
  constructor(props) {
    super(props);
    const { enums, loggedUser } = props || {};
    const { CoatOfArmsAppearance, NationalMinorities } = enums || {};

    this.state = {
      activeStep: 0,
      referenceNumber: '',
      organizationalUnit: null,
      organizationalUnit2: null,
      organizationalUnit3: null,
      organizationalUnitPlace: null,
      registrationNumber: null,
      uniqueNumberKJS: null,
      countryName: 'Република Србија',
      note: null,
      coatOfArmsAppearances: checkIfUserHasAutonomousProvince(loggedUser)
        ? [
            CoatOfArmsAppearance.LARGE_RS,
            CoatOfArmsAppearance.SMALL_RS,
            CoatOfArmsAppearance.TRADITIONAL_APV,
          ]
        : [CoatOfArmsAppearance.LARGE_RS, CoatOfArmsAppearance.SMALL_RS],
      nationalMinorities: [
        NationalMinorities.CRNOGORCI,
        NationalMinorities.HRVATI,
        NationalMinorities.BUNJEVCI,
        NationalMinorities.BUGARI,
        NationalMinorities.BOSNJACI,
        NationalMinorities.MADJARI,
        NationalMinorities.ROMI,
        NationalMinorities.RUMUNI,
        NationalMinorities.RUSINI,
        NationalMinorities.SLOVACI,
        NationalMinorities.ALBANCI,
        NationalMinorities.VLASI,
        NationalMinorities.CESI,
        NationalMinorities.MAKEDONCI,
      ],
      languageAndScript: languageAndScript.CYRILLIC,
      isOnSerbianLatin: false,
      isOnNationalMinoritiesLanguage: null,
      signetForm: false,
      signetSizes: ['Мали печат', 'Велики печат'],
      signetNumber: null,
      ordinalNumber: null,
      signetView: [],
      uploadedFiles: [],
      autonomousProvince: null,
      place: null,
      municipality: null,
      institutionType: null,
      kjsMunicipality: null,
      institutionName: null,
      coatOfArmsAppearance: checkIfUserHasAutonomousProvince(loggedUser)
        ? CoatOfArmsAppearance.TRADITIONAL_APV
        : null,
      nationalMinority: null,
      signetSize: null,
      selectedNationalMinoitites: [],
      isElSignet: true,
      status: null,
      attachmentsForDelete: [],
      attachmentsForPreview: [],
    };
  }

  handleSetCoatOfApperance = (value) => {
    this.setState({ coatOfArmsAppearance: value });
  };

  componentDidMount() {
    const { CoatOfArmsAppearance, NationalMinorities } = this.props.enums || {};
    const requestForSignetApproval = this.props.requestForSignetApproval;
    const { kjsMunicipality } = requestForSignetApproval || {},
      { kjs, municipality } = kjsMunicipality || {};
    const arrayOfEmbeddableAttributes = this.props
      .requestForSignetApprovalAttachmentList;

    this.props.loggedUser?.id &&
      this.props.findUserById(this.props.loggedUser?.id);
    requestForSignetApproval &&
      this.setState({
        ...requestForSignetApproval,
        isOnSerbianLatin: requestForSignetApproval.onSerbianLatin,
        isOnNationalMinoritiesLanguage:
          requestForSignetApproval.onNationalMinoritiesLanguage,
        languageAndScript:
          languageAndScript[requestForSignetApproval.languageAndScript],
        institutionType: kjs?.institutionType || null,
        municipality: municipality || null,
        place: municipality?.place || null,
        autonomousProvince: municipality?.place?.autonomousProvince || null,
        coatOfArmsAppearance:
          requestForSignetApproval?.coatOfArmsAppearance &&
          CoatOfArmsAppearance[requestForSignetApproval?.coatOfArmsAppearance],
        selectedNationalMinoitites:
          requestForSignetApproval.nationalMinorities?.map(
            (minority) => NationalMinorities[minority]
          ) || [],
        isElSignet: requestForSignetApproval.elSignet,
        nationalMinorities: this.state.nationalMinorities,
        signetNumber: requestForSignetApproval.numberOfSignets,
        attachmentsForPreview: arrayOfEmbeddableAttributes,
      });
  }

  getStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <FirstStep
            countryName={this.state.countryName}
            autonomousProvinceList={this.props.autonomousProvinceList}
            placeList={this.props.placeList}
            municipalityList={this.props.municipalityList}
            kjsList={this.props.kjsList}
            institutionTypeList={this.props.institutionTypeList}
            institutionNames={this.state.institutionNames}
            onChange={this.onChange}
            changeComboAutocomplete={this.changeComboAutocomplete}
            organizationalUnit={this.state.organizationalUnit}
            organizationalUnit2={this.state.organizationalUnit2}
            organizationalUnit3={this.state.organizationalUnit3}
            organizationalUnitPlace={this.state.organizationalUnitPlace}
            autonomousProvince={this.state.autonomousProvince}
            place={this.state.place}
            municipality={this.state.municipality}
            institutionType={this.state.institutionType}
            kjsMunicipality={this.state.kjsMunicipality}
            referenceNumber={this.state.referenceNumber}
            errors={this.state.errors}
            loggedUser={this.props.loggedUser}
          />
        );
      case 1:
        return (
          <SecondStep
            handleSetCoatOfApperance={this.handleSetCoatOfApperance}
            coatOfArmsAppearances={this.state.coatOfArmsAppearances}
            onChange={this.onChange}
            changeComboAutocomplete={this.changeComboAutocomplete}
            signetSizes={this.state.signetSizes}
            handleCheckChoiceSet={this.handleCheckChoiceSet}
            signetForm={this.state.signetForm}
            languageAndScript={this.state.languageAndScript}
            nationalMinorities={this.state.nationalMinorities}
            isOnNationalMinoritiesLanguage={
              this.state.isOnNationalMinoritiesLanguage
            }
            signetNumber={this.state.signetNumber}
            ordinalNumber={this.state.ordinalNumber}
            coatOfArmsAppearance={this.state.coatOfArmsAppearance}
            nationalMinority={this.state.nationalMinority}
            signetSize={this.state.signetSize}
            selectedNationalMinoitites={this.state.selectedNationalMinoitites}
            isOnSerbianLatin={this.state.isOnSerbianLatin}
            isElSignet={this.state.isElSignet}
            autonomousProvince={this.state.autonomousProvince}
            errors={this.state.errors}
            user={this.props.user}
            loggedUser={this.props.loggedUser}
          />
        );
      case 2:
        return (
          <ThirdStep
            onFileChange={this.onFileChange}
            onChange={this.onChange}
            handleDeleteDocument={this.handleDeleteDocument}
            handleDeleteDocumentUploaded={this.handleDeleteDocumentUploaded}
            uploadedFiles={this.state.uploadedFiles}
            attachmentsForPreview={this.state.attachmentsForPreview}
            note={this.state.note}
            errors={this.state.errors}
            downloadAttachment={this.props.downloadAttachment}
          />
        );
      default:
        throw new Error('Unknown step');
    }
  };

  handleNext = () => {
    if (this.handleStepValidation()) return;
    this.setState({
      activeStep: this.state.activeStep + 1,
    });
  };

  handleBack = () => {
    this.setState({
      activeStep: this.state.activeStep - 1,
    });
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  changeComboAutocomplete = (name, newValue) => {
    switch (name) {
      case 'autonomousProvince':
        if (!newValue) {
          this.setState({ coatOfArmsAppearance: null });
        } else {
          this.setState({
            coatOfArmsAppearance: this.state.coatOfArmsAppearances[2],
          });
        }
        this.setState({
          autonomousProvince: newValue,
        });
        break;
      case 'kjsMunicipality':
        if (!newValue) {
          this.setState({
            kjsMunicipality: newValue,
            institutionType: null,
            municipality: null,
            place: null,
          });
        } else {
          this.setState({
            kjsMunicipality: newValue,
            institutionType: newValue.kjs.institutionType,
            municipality: newValue.municipality,
            place: newValue.municipality.place,
          });
        }
        break;
      case 'nationalMinority':
        this.setState({
          selectedNationalMinoitites: newValue,
        });
        break;
      default:
        this.setState({ [name]: newValue });
        break;
    }
  };

  onFileChange = (e) => {
    const filesForUpload = getFilesForUpload(e.target.files);
    filesForUpload &&
      this.setState({
        [e.target.name]: this.state[e.target.name].concat(filesForUpload),
      });
  };

  handleDeleteDocument = (documentName) => {
    let uploadedDocumentsNames = [];
    let uploadedDocumentsAsArray = Array.from(this.state.uploadedFiles);

    for (let i = 0; i < this.state.uploadedFiles.length; i++) {
      uploadedDocumentsNames.push(this.state.uploadedFiles[i].name);
    }

    const index = uploadedDocumentsNames.indexOf(documentName);
    uploadedDocumentsAsArray.splice(index, 1);
    this.setState({
      uploadedFiles: uploadedDocumentsAsArray,
    });
  };

  handleDeleteDocumentUploaded = (attachment) => {
    let uploadedDocumentsNames = [];
    let uploadedDocumentsAsArray = Array.from(this.state.attachmentsForPreview);

    for (let i = 0; i < this.state.attachmentsForPreview.length; i++) {
      uploadedDocumentsNames.push(
        this.state.attachmentsForPreview[i].embeddableAttribute.name
      );
    }

    const index = uploadedDocumentsNames.indexOf(
      attachment.embeddableAttribute.name
    );
    uploadedDocumentsAsArray.splice(index, 1);
    this.setState({
      attachmentsForPreview: uploadedDocumentsAsArray,
      attachmentsForDelete: this.state.attachmentsForDelete.concat(attachment),
    });
  };

  handleCheckChoiceSet = (name, choice1, choice2) => {
    switch (name) {
      case 'signetForm':
        this.setState({ signetForm: choice2 });
        break;
      case 'isOnSerbianLatin':
        choice1 &&
          this.setState({
            languageAndScript: languageAndScript.CYRILLIC_AND_LATIN,
            isOnSerbianLatin: true,
          });
        choice2 &&
          this.setState({
            languageAndScript: languageAndScript.CYRILLIC,
            isOnSerbianLatin: false,
          });
        break;
      case 'isOnNationalMinoritiesLanguage':
      default:
        choice2 &&
          this.setState({
            selectedNationalMinoitites: [],
          });
        this.setState({ [name]: choice1 });
        break;
    }
  };

  handleQuit = () => {
    const { t, gt } = this.props || {},
      { ConfirmDialog } = t || {},
      { confirmDelete, confirmMessage } = ConfirmDialog || {};
    const action = () => {
      this.props.handleClose();
    };
    confirmDialog(confirmMessage, action, confirmDelete, gt);
  };

  setRequestForApprovalData = (status) => {
    const { kjsList } = this.props.loggedUser || {};
    const {
      isOnSerbianLatin,
      isOnNationalMinoritiesLanguage,
      note,
      ordinalNumber,
      referenceNumber,
      selectedNationalMinoitites,
      coatOfArmsAppearance,
      isElSignet,
      autonomousProvince,
      signetNumber,
      organizationalUnit,
      organizationalUnit2,
      organizationalUnit3,
      organizationalUnitPlace,
      kjsMunicipality,
    } = this.state;

    const newRequestForSignetApproval = {
      ...this.props.requestForSignetApproval,
      kjsMunicipality: kjsMunicipality || kjsList[0],
      onSerbianLatin: isOnSerbianLatin,
      note,
      onNationalMinoritiesLanguage: isOnNationalMinoritiesLanguage,
      ordinalNumber,
      referenceNumber,
      status,
      nationalMinorities: selectedNationalMinoitites?.map((item) => item.value),
      coatOfArmsAppearance: coatOfArmsAppearance?.value || null,
      elSignet: isElSignet,
      autonomousProvince,
      numberOfSignets: signetNumber,
      organizationalUnit,
      organizationalUnit2,
      organizationalUnit3,
      organizationalUnitPlace,
    };

    let formData = new FormData();

    if (this.state.uploadedFiles.length > 0) {
      for (let i = 0; i < this.state.uploadedFiles.length; i++) {
        formData.append('files', this.state.uploadedFiles[i]);
        formData.append('name', this.state.uploadedFiles[i].name);
      }
    } else {
      formData.append('files', this.state.uploadedFiles);
    }
    formData.append(
      'filesForDelete',
      new Blob([JSON.stringify(this.state.attachmentsForDelete)], {
        type: 'application/json',
      })
    );

    formData.append(
      'requestForSignetApproval',
      new Blob([JSON.stringify(newRequestForSignetApproval)], {
        type: 'application/json',
      })
    );

    return formData;
  };

  handleSave = () => {
    const { handleAdd, requestForSignetApproval, t } = this.props || {};
    const { NotificationMessages } = t || {};

    const status =
      requestForSignetApproval?.status ||
      requestForSignetApprovalStatuses.IN_PREPARATION.name;

    if (
      status ===
        requestForSignetApprovalStatuses.REQUIRED_COMPLEMENTATION.name &&
      this.hadnleFinalValidation()
    ) {
      createNotification(
        notificationTypeError,
        NotificationMessages.requestTitle,
        NotificationMessages.draftUnsuccess
      );
      return;
    }

    handleAdd(this.setRequestForApprovalData(status), status);
  };

  handleSubmit = () => {
    const { handleAdd, enums } = this.props || {};
    if (this.handleStepValidation(true)) return;
    handleAdd(
      this.setRequestForApprovalData(enums.Status.SUBMIT.value),
      enums.Status.SUBMIT.value
    );
  };

  handleUploadValidation = (errors, uploadedData, submitSignal) => {
    let hasError = false;
    const { Errors } = this.props.t || {};

    if (checkFileFormat(this.state.uploadedFiles)) {
      errors['uploadedFiles'] = Errors.invalidFormat;
      hasError = true;
    }

    if (
      this.state.uploadedFiles?.length === 0 &&
      !this.props.requestForSignetApprovalAttachmentList
    ) {
      errors['uploadedFiles'] = Errors.uploadedFilesEmpty;
      hasError = true;
    }
    if (submitSignal)
      if (
        this.state.uploadedFiles?.length === 0 &&
        this.state.attachmentsForDelete?.length ===
          this.props.requestForSignetApprovalAttachmentList?.length
      ) {
        {
          errors['uploadedFiles'] = Errors.uploadedFilesEmpty;
          hasError = true;
        }
      }

    if (this.state.uploadedFiles.length > 0) {
      let uploadedDataSize = 0;
      for (let i = 0; i < this.state.uploadedFiles.length; i++) {
        uploadedDataSize += this.state.uploadedFiles[i].size;
      }
      if (uploadedDataSize >= uploadFileMaxSize) {
        errors['uploadedFiles'] = Errors.invalidFileSize;
        hasError = true;
      }
    }

    this.setState({ errors });
    return hasError;
  };

  hadnleFinalValidation = () => {
    let hasError = false;
    let errors = {};
    const { Errors } = this.props.t || {};

    if (!this.state.signetNumber) {
      errors['signetNumber'] = Errors.signetNumberEmpty;
      hasError = true;
    }
    if (!this.state.coatOfArmsAppearance) {
      errors['coatOfArmsAppearance'] = Errors.coatOfArmsAppearanceEmpty;
      hasError = true;
    }

    if (checkFileFormat(this.state.uploadedFiles)) {
      errors['uploadedFiles'] = Errors.invalidFormat;
      hasError = true;
    }

    if (
      this.state.uploadedFiles?.length === 0 &&
      !this.props.requestForSignetApprovalAttachmentList
    ) {
      errors['uploadedFiles'] = Errors.uploadedFilesEmpty;
      hasError = true;
    }
    if (
      this.state.uploadedFiles?.length === 0 &&
      this.state.attachmentsForDelete?.length ===
        this.props.requestForSignetApprovalAttachmentList?.length
    ) {
      errors['uploadedFiles'] = Errors.uploadedFilesEmpty;
      hasError = true;
    }

    if (this.state.uploadedFiles.length > 0) {
      let uploadedDataSize = 0;
      for (let i = 0; i < this.state.uploadedFiles.length; i++) {
        uploadedDataSize += this.state.uploadedFiles[i].size;
      }
      if (uploadedDataSize >= uploadFileMaxSize) {
        errors['uploadedFiles'] = Errors.invalidFileSize;
        hasError = true;
      }
    }

    this.setState({ errors });
    return hasError;
  };

  handlePreparationUploadValidation = (errors, uploadedData) => {
    let hasError = false;
    const { Errors } = this.props.t || {};

    if (this.state.uploadedFiles) {
      if (checkFileFormat(this.state.uploadedFiles)) {
        errors['uploadedFiles'] = Errors.invalidFormat;
        hasError = true;
      }
    }

    if (this.state.uploadedFiles.length > 0) {
      let uploadedDataSize = 0;
      for (let i = 0; i < this.state.uploadedFiles.length; i++) {
        uploadedDataSize += this.state.uploadedFiles[i].size;
      }
      if (uploadedDataSize >= uploadFileMaxSize) {
        errors['uploadedFiles'] = Errors.invalidFileSize;
        hasError = true;
      }
    }

    this.setState({ errors });
    return hasError;
  };

  handleStepValidation = (submitSignal) => {
    const { Errors } = this.props.t || {};
    let hasError = false;
    let errors = {};
    const { uploadedFiles } = this.state;

    switch (this.state.activeStep) {
      case 1:
        if (!this.state.signetNumber || this.state.signetNumber === '0') {
          errors['signetNumber'] = Errors.signetNumberEmpty;
          hasError = true;
        }
        if (!this.state.coatOfArmsAppearance) {
          errors['coatOfArmsAppearance'] = Errors.coatOfArmsAppearanceEmpty;
          hasError = true;
        }
        break;
      case 2:
        if (this.handleUploadValidation(errors, uploadedFiles, submitSignal)) {
          hasError = true;
        }
        break;
      default:
        break;
    }

    this.setState({ errors });
    return hasError;
  };

  render() {
    const { classes, t, isPreview, requestForSignetApproval, enums } =
      this.props || {};
    const { activeStep } = this.state;
    const submitLabel =
      activeStep !== 2 ? t.Buttons.save : t.Buttons.saveFinalStep;
    const formStyle = isPreview && 'preview-style';
    const isSubmitVisible =
      requestForSignetApproval?.status === enums.Status.IN_PREPARATION.value ||
      this.state.status === null;

    return (
      <Fragment>
        <CssBaseline />
        <br />
        <div className="container col-md-12 wrapper-fade-in">
          <main className={classes.layout}>
            <Paper className={classes.paper}>
              <Typography component="h1" variant="h4" align="center">
                {t.title}
              </Typography>
              <Stepper activeStep={activeStep} className={classes.stepper} />
              <Fragment>
                <div disabled className={formStyle}>
                  {this.getStepContent(activeStep)}
                </div>
                <div className={classes.buttons + ' col-md-12 row mt-3'}>
                  {activeStep !== 0 && (
                    <Button
                      onClick={this.handleBack}
                      className={classes.button + ' mr-auto mt-3'}
                    >
                      <KeyboardBackspaceIcon className="mr-2 red-color" />
                      {t.Buttons.back}
                    </Button>
                  )}
                  {!isPreview && (
                    <div className="pr-5 ml-auto">
                      <Button
                        variant="contained"
                        onClick={this.handleQuit}
                        className={classes.button}
                      >
                        {t.Buttons.quit}
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={this.handleSave}
                        className={classes.button}
                      >
                        {submitLabel}
                      </Button>
                    </div>
                  )}
                  {activeStep < 2 ? (
                    <div className={isPreview && 'ml-auto'}>
                      <Button
                        onClick={this.handleNext}
                        className={classes.button}
                      >
                        {t.Buttons.next}
                        <KeyboardBackspaceIcon className="flip-horizontal ml-2 red-color" />
                      </Button>
                    </div>
                  ) : (
                    !isPreview &&
                    isSubmitVisible && (
                      <Button
                        variant="contained"
                        onClick={this.handleSubmit}
                        color="primary"
                        className={classes.button}
                      >
                        {t.Buttons.submit}
                      </Button>
                    )
                  )}
                </div>
              </Fragment>
            </Paper>
          </main>
        </div>
      </Fragment>
    );
  }
}

export default withStyles(useStyles)(
  withTranslations(RequestForSignetApprovalForm, 'RequestForSignetApprovalForm')
);
